import gsap from 'gsap';
import { cn } from 'lib/utils';
import { FC, useLayoutEffect, useRef } from 'react';

interface EyeProps {
  id?: string;
  showBorder?: boolean;
  zoomDown?: boolean;
  onZoomDownComplete?: () => void;
  width?: number | null;
  height?: number | null;
}

const Eye: FC<EyeProps> = ({
  id = 'eye-video',
  showBorder = false,
  zoomDown = false,
  onZoomDownComplete = () => {},
  width = null,
  height = null,
}) => {
  const videoRef = useRef<HTMLVideoElement>(null);

  useLayoutEffect(() => {
    if (zoomDown)
      gsap.from(videoRef.current, {
        scale: 4,
        borderWidth: '0',
        alpha: 0,
        duration: 0.9,
        ease: 'power3.out',
        delay: 0.4,
        onComplete: onZoomDownComplete,
      });
  }, [zoomDown]);

  return (
    <video
      id={id}
      ref={videoRef}
      className={cn(
        'block relative w-max-[370px] h-full overflow-hidden rounded-[50%] m-auto',
        showBorder ? 'border-[4px] border-gray-800' : ''
      )}
      src={`${process.env.PUBLIC_URL}/video/eye.mp4`}
      autoPlay
      muted
      loop
      playsInline
      width={width || undefined}
      height={height || undefined}
    />
  );
};

interface OnboardingEyeProps {
  zoomDown?: boolean;
  onZoomDownComplete?: () => void;
  width?: number;
}

export const OnboardingEye: FC<OnboardingEyeProps> = ({
  zoomDown = false,
  onZoomDownComplete = () => {},
  width = 40,
}) => (
  <div
    className="block relative"
    style={{ width: `${width}px`, height: `${width}px` }}
  >
    <div>
      <Eye
        showBorder
        zoomDown={zoomDown}
        onZoomDownComplete={onZoomDownComplete}
        width={width}
        height={width}
      />
    </div>
  </div>
);

export default Eye;
